import { useMemo } from "react";
import apiInstance from "../../helpers/apiInstance";
import { useApp } from "../../contexts/AppContext";
import { useParams } from "react-router-dom";

function useInvitations() {
  const { organizationId } = useApp();

  const basePath = useMemo(() => {
    return `/invitation/${organizationId}`;
  }, [organizationId]);

  const { token } = useParams();

  return {
    sendInvitation: (payload) => apiInstance.post(basePath + "/send", payload),
    resendInvitation: (payload) =>
      apiInstance.post(basePath + "/resend", payload),
    checkInvitation: () =>
      apiInstance.post("invitation/check-invitation/" + token),
    acceptInvitation: () =>
      apiInstance.post("invitation/accept-invitation/" + token),
    registerInvitedUser: (payload) =>
      apiInstance.post("invitation/register-invited-user/" + token, payload),
  };
}

export default useInvitations;
